<template>
    <div id="PerformanceInspect">
        <el-card class="table_searchbar">
            <el-row style="margin-bottom:20px">
                <el-col :span="5">
                    <div class="y_table" @keydown.enter="btnSearch()">
                        <span class="title y_table_span">报工日期：</span>
                        <el-date-picker style="width:70%;" v-model="searchForm.date" value-format="yyyy-MM-dd" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"></el-date-picker>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="y_table" @keydown.enter="btnSearch()">
                        <span style="width:100px;" class="title y_table_span">执行组名称：</span>
                        <el-select clearable filterable v-model='searchForm.executionGroupId' class="y_table_cellLogy" style="min-width:100px ;max-width: 200px" size='small' placeholder='执行组名称' >
                            <el-option v-for="item in groupNameList" :key="item.id" :value="item.id" :label="item.groupName"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="y_table" @keydown.enter="btnSearch()">
                        <span class="title y_table_span">工单号：</span>
                        <el-select :loading="loading" style="max-width: 200px" @visible-change="ev=>{if(!ev){loadProductionBatchCode('')}}" clearable :remote-method="query => loadProductionBatchCode(query)" v-model="searchForm.productionBatchCode" filterable placeholder="工单号" remote>
                            <el-option v-for="item in productionBatchCodeList" :key="item.splitId" :label="item.productionBatchCode" :value="item.productionBatchCode"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="y_table" @keydown.enter="btnSearch()">
                        <span class="title y_table_span">物料信息：</span>
                        <el-select popper-class='width180' @visible-change="ev=>{if(!ev){remoteMethod('')}}" :loading="loading" style="max-width: 200px"  clearable :remote-method="query=>remoteMethod(query)"   v-model="searchForm.materialId" filterable  placeholder="物料信息" remote>
                            <el-option v-for="item in materialList" :key="item.materialId" :label="`${item.materialName}/${item.materialCode}`" :value="item.materialId"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div style="text-align:right">
                        <a style="margin-right: 12px;cursor: pointer;font-size: 12px;" @click="toggleShowMore">
                            {{ showMore ? '收起' : '展开' }}
                            <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
                        </a>
                        <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
                        <el-button size="mini" icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                    </div>
                </el-col>
            </el-row>
            <el-collapse-transition>
                <div v-show="showMore">
                    <el-row style="margin-bottom:20px">
                        <el-col :span="5">
                            <div class="y_table" @keydown.enter="btnSearch()">
                                <span class="title y_table_span">材质：</span>
                                <el-select size="small" style="min-width:100px ;max-width: 200px" clearable filterable v-model="searchForm.materialQualityName" placeholder="材质">
                                    <el-option v-for="item in textureList" :key="item.name" :label="item.name" :value="item.name"></el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="y_table" @keydown.enter="btnSearch()">
                                <span style="width:100px;" class="title y_table_span">工序名称：</span>
                                <el-select clearable filterable v-model='searchForm.procedureName' class="y_table_cellLogy" style="min-width:100px ;max-width: 200px" size='small' placeholder='工序名称' >
                                    <el-option style="max-width: 200px" :title="item" v-for="item in procedureList" :key="item" :label="item" :value="item"></el-option>
                                </el-select>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-collapse-transition>
        </el-card>
        <el-card class="table-card">
            <el-row :gutter="20">
                <el-col :span="16">
                    <el-table border :data="groupData" highlight-current-row @row-click="clickData" class="user-table-list" style="width: 100%">
                        <el-table-column prop="productionBatchCode" label="工单号" show-overflow-tooltip align="center"></el-table-column>
                        <el-table-column prop="materialName" label="物料信息" show-overflow-tooltip align="center"></el-table-column>
                        <el-table-column prop="materialQualityName" label="材质" show-overflow-tooltip align="center"></el-table-column>
                        <el-table-column prop="procedureName" label="工序名称" show-overflow-tooltip align="center"></el-table-column>
                        <el-table-column prop="actualFinishedAmount" label="有效报工数" show-overflow-tooltip align="center"></el-table-column>
                        <el-table-column prop="gmtCreate" label="报工日期" show-overflow-tooltip align="center"></el-table-column>
                        <el-table-column prop="name" label="执行组名称" show-overflow-tooltip align="center"></el-table-column>
                    </el-table>
                    <div class="page">
                        <div class="pagesContent">
                            <el-pagination @size-change="handleSizeChange" @current-change="pageChange" :current-page="tableCurrentPage" 
                                layout="total, prev, pager, next, jumper" :total="tableTotalPage">
                            </el-pagination>
                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <el-table border :data="groupMembers" highlight-current-row class="user-table-list" style="width: 100%">
                        <el-table-column prop="userName" label="姓名" show-overflow-tooltip align="center"></el-table-column>
                        <el-table-column prop="factor" label="系数" show-overflow-tooltip align="center"></el-table-column>
                        <el-table-column prop="achievements" label="绩效" show-overflow-tooltip align="center"></el-table-column>
                        <el-table-column :key="Math.random()" show-overflow-tooltip align="center">
                            <template slot="header">
                                <span>操作</span>
                                <el-tooltip class="item" effect="dark" content="新增" placement="top">
                                    <i style="color:#409EFF;cursor:pointer;" v-if="permission.btn_production_plan_detail_execution_group_create&&currentProductionPlanDetailId" @click="addBtn" class="el-icon-circle-plus-outline"></i>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <el-button @click="editBtn(scope.row)" type="text" size="small" v-if="permission.btn_production_plan_detail_execution_group_update">编辑</el-button>
                                <el-button class="btn-del" @click="deleteBtn(scope.row)" type="text" size="small" v-if="permission.btn_production_plan_detail_execution_group_delete">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-card>
        <el-dialog title="新增" :visible.sync="addDialogVisible" width="35%" center :close-on-click-modal="false" :before-close="addClose">
            <el-form :model="addForm" :rules="rules" ref="addForm" label-width="100px">
                <el-row class="form-row" :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="userId" label="员工">
                            <el-select clearable v-model='addForm.userId' size='small' placeholder='员工' :style="W?{maxWidth:'200px'}:{maxWidth:'160px'}">
                                <el-option v-for="item in userList" :key="item.id" :value="item.id" :label="item.userName"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="factor" label="系数">
                            <el-input v-model="addForm.factor" maxlength="3"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addSave">确 定</el-button>
                <el-button @click="addClose">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog title="编辑" :visible.sync="editDialogVisible" width="35%" center :close-on-click-modal="false" :before-close="editClose">
            <el-form :model="editForm" :rules="rules" ref="editForm" label-width="100px">
                <el-row class="form-row" :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="userId" label="员工">
                            <el-select disabled clearable v-model='editForm.userId' size='small' placeholder='员工' :style="W?{maxWidth:'200px'}:{maxWidth:'160px'}">
                                <el-option v-for="item in userList" :key="item.id" :value="item.id" :label="item.userName"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="factor" label="系数">
                            <el-input v-model="editForm.factor" maxlength="3"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="editSave">确 定</el-button>
                <el-button @click="editClose">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name:'PerformanceInspect',
    data(){
        return{
            showMore:false,
            userList:[],
            currentProductionPlanDetailId:'',
            addDialogVisible:false,
            addForm:{
                userId:'',
                factor:'',
            },
            editDialogVisible:false,
            editForm:{
                userId:'',
                factor:'',
            },
            W:false,
            rules:{
                userId: [
                    { required: true, message: '请选择员工', trigger: ['blur','change'] }
                ],
                factor:[
                    { required: true, message: '请输入系数', trigger: 'blur' },
                    {validator(rule, value, callback) {
                        if(value){
                            value = Number(value)
                            if(isNaN(value)||value<=0){
                                callback(new Error('系数必须为大于0的数字'))
                            }else{
                                callback()
                            }
                        }else{
                            callback()
                        }
					},trigger: 'blur'}
                ]
            },
            groupData:[],
            groupMembers:[],
            loading:false,
            groupNameList:[],
            materialList:[],
            productionBatchCodeList: [],
            procedureList: [],
            textureList:[],
            searchForm:{
                date:[],
                executionGroupId:'',
                productionBatchCode:'',
                materialId:'',
                materialQualityName:'',
                procedureName:''
            },
            tableCurrentPage: 1,
            tableTotalPage: 0,
            fristLoad: false,
            permission: JSON.parse(localStorage.getItem("permission")),
        }
    },
    mounted(){
        this.loadTextureList()
        this.loadProductionBatchCode();
        this.loadProcedureList();
        this.remoteMethod();
        this.getGroupNameList();
        this.search();
        this.getUserList();
    },
    methods:{
        toggleShowMore(){
            this.showMore = ! this.showMore
        },
        getUserList(){
            this.$RequestUtil.get({
                url: "/api/executionGroup/user-optional",
                params: {},
                success: res => {
                    if (res.code == 0) {
                        this.userList = res.data;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg
                        });
                    }
                }
            });
        },
        addBtn(){
            this.addDialogVisible = true;
        },
        addSave(){
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    this.$RequestUtil.post({
                        url: '/api/production-plan-detail-execution-group/create',
                        params: {
                            productionPlanDetailId:this.currentProductionPlanDetailId,
                            userId: this.addForm.userId,
                            factor: Number(this.addForm.factor),
                        },
                        success: (res) => {
                            if (res.code == 0) {
                                this.$message({
                                    type: 'success',
                                    message: '新增成功'
                                })
                                this.addClose();
                                this.executionGroupList();
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.message
                                });
                            }
                        }
                    });
                }
            })
        },
        addClose(){
            this.$refs['addForm'].resetFields();
            this.addDialogVisible = false;
        },
        editBtn(row){
            this.editForm.id = row.id;
            this.editForm.userId = row.userId;
            this.editForm.factor = row.factor;
            this.editDialogVisible = true;
        },
        editSave(){
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    this.$RequestUtil.post({
                        url: '/api/production-plan-detail-execution-group/update',
                        params: {
                            productionPlanDetailId:this.currentProductionPlanDetailId,
                            id:this.editForm.id,
                            userId: this.editForm.userId,
                            factor: Number(this.editForm.factor),
                        },
                        success: (res) => {
                            if (res.code == 0) {
                                this.$message({
                                    type: 'success',
                                    message: '编辑成功'
                                })
                                this.editClose();
                                this.executionGroupList();
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.message
                                });
                            }
                        }
                    });
                }
            })
        },
        editClose(){
            this.$refs['editForm'].resetFields();
            this.editDialogVisible = false;
        },
        deleteBtn(row){
            this.$confirm('是否确定删除, 是否继续?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.get({
                    url: '/api/production-plan-detail-execution-group/delete',
                    type: 'sync',
                    params: {
                        id: row.id
                    },
                    success: (res) => {
                        if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.executionGroupList();
                        } else if (res.code == -1) {
                            this.$message({
                                type: 'error',
                                message: '删除失败!'
                            });
                        }
                    },

                });
            });
        },
        clickData(row){
            this.currentProductionPlanDetailId = row.id;
            this.executionGroupList();
        },
        executionGroupList(){
            this.$RequestUtil.get({
                url: "/api/production-plan-detail-execution-group/list",
                type: "sync",
                params: {
                    productionPlanDetailId:this.currentProductionPlanDetailId
                },
                success: res => {
                    if (res.code === 0) {
                        this.groupMembers = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                }
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.pageNum = 1;
            this.search();
            this.currentProductionPlanDetailId = "";
            this.groupMembers = [];
        },
        async loadTextureList(){
            let {data} = await this.$RequestUtil.getAsync({url: '/api/masterData/material-quality/list',params:{}})
            this.textureList = data
        },
        async remoteMethod(webSearchStr){
            this.loading = true
            let {data} = await this.$RequestUtil.getAsync({url: '/api/select/listMaterial',type:'sync',params: {webSearchStr} ,})
            this.materialList = data;
            this.loading = false
        },
        async loadProductionBatchCode(productionBatchCode) {
            this.loading = true;
            let { data, code, msg, message } = await this.$RequestUtil.getAsync({
                url: "/api/select/listProductionBatchCode",
                type: "async",
                params: { productionBatchCode }
            });
            this.productionBatchCodeList = data;
            this.loading = false;
        },
        async loadProcedureList(procedureName) {
            this.loading = true;
            let { data } = await this.$RequestUtil.getAsync({
                url: "/api/select/listProcedure",
                type: "sync",
                params: { procedureName }
            });
            this.procedureList = data;
            this.loading = false;
        },
        getGroupNameList(){
            this.$RequestUtil.post({
                url: "/api/executionGroup/page",
                params: {
                    pageNum: 1,
                    pageSize: 10000
                },
                success: res => {
                    if (res.code == 0) {
                        this.groupNameList = res.data.list;
                    }
                }
            });
        },
        btnSearch(){
            this.tableCurrentPage = 1;
            this.search();
            this.currentProductionPlanDetailId = "";
            this.groupMembers = [];
        },
        clearSearch(){
            this.searchForm.executionGroupId = '';
            this.searchForm.materialId = '';
            this.searchForm.materialQualityName = '';
            this.searchForm.procedureName = '';
            this.searchForm.productionBatchCode = '';
            this.searchForm.date = []
        },
        pageChange: function (targetPage) {
            this.tableCurrentPage = targetPage;
            this.search();
            this.currentProductionPlanDetailId = "";
            this.groupMembers = [];
        },
        search(){
            this.$RequestUtil.loading();
            this.$RequestUtil.post({
                url: '/api/productionPlanDetail/execution-group/page',
                type:'sync',
                params: {
                    pageNum: this.tableCurrentPage,
                    pageSize: 10,
                    executionGroupId:this.searchForm.executionGroupId,
                    materialId:this.searchForm.materialId,
                    materialQualityName:this.searchForm.materialQualityName,
                    procedureName:this.searchForm.procedureName,
                    productionBatchCode:this.searchForm.productionBatchCode,
                    startDate:this.searchForm.date.length!=0?this.searchForm.date[0]:'',
                    endDate:this.searchForm.date.length!=0?this.searchForm.date[1]:''
                },
                success: (res) => {
                    this.$RequestUtil.loading().close()
                    if (res.msg == "success") {
                        this.groupData = res.data.list;
                        this.tableTotalPage = res.data.total;
                        if (res.data.total == 0 && this.fristLoad) {
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        this.fristLoad = true
                    } else {
                        this.$message.error(res.message || res.msg)
                    }

                }
            });
        }
    }
}
</script>
<style scoped>
.page {
    display: flex;
    justify-content: flex-end;
}

.total_page {
    margin-top: 8px;
    margin-right: 26px;
    color: #606266;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/Rework/PerformanceInspect.vue